import type { OnInit } from '@angular/core';
import { Directive, Inject, Input, Optional } from '@angular/core';

import type { AnalyticsViewContext } from '@core/analytics-legacy';
import { Analytics, ANALYTICS_VIEW_CONTEXT } from '@core/analytics-legacy';
import { I18nService } from '@core/i18n-legacy';

import type { HelpTranslationLinkMapKey } from './types';
import { HelpTranslationLinkMap } from './types';

@Directive({
  standalone: true,
  selector: '[rtHelpArticle]',
  host: {
    '[attr.href]': 'href',
    '[attr.target]': '"_blank"',
    '(click)': 'onClick()',
  },
})
export class HelpArticlesDirective implements OnInit {
  private readonly namespace = 'HelpArticleLinkClick';

  @Input() public rtHelpArticle: HelpTranslationLinkMapKey;

  public href: string;

  constructor(
    private i18nService: I18nService,
    private analytics: Analytics,
    @Optional() @Inject(ANALYTICS_VIEW_CONTEXT) private viewContext: AnalyticsViewContext[],
  ) {}

  public ngOnInit(): void {
    this.href = this.resolveHelpArticleURL();
  }

  public onClick(): void {
    if (!this.href) return;

    const eventProps = {
      url: this.href,
      key: this.rtHelpArticle,
      ...(this.viewContext?.length ? { viewContext: this.viewContext } : {}),
    };

    this.analytics.track(this.namespace, eventProps);
  }

  private resolveHelpArticleURL(): string {
    if (!this.rtHelpArticle || !HelpTranslationLinkMap[this.rtHelpArticle])
      throw new Error('Invalid help article key identifier');

    return this.i18nService.translate(HelpTranslationLinkMap[this.rtHelpArticle]);
  }
}
